import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import React from "react";
import { ReactComponent as CloseIcon } from "Assets/Icons/Home/CloseIcon.svg";
import { useSelector } from "react-redux";

const CompleteSolutionConfirmation = ({ open, setOpen, handleUnlock }) => {
  const handleClose = () => {
    setOpen(false);
  };

  const { Translation } = useSelector((state) => ({
    Translation: state.Translation.translation?.Course || {},
  }));

  return (
    <Dialog fullWidth maxWidth={"xs"} open={open} onClose={handleClose}>
      <DialogTitle>
        {Translation?.AccessCompleteSolution}{" "}
        <IconButton onClick={() => handleClose()}>
          {" "}
          <PrimaryIcon
            icon={CloseIcon}
            color="white"
            height="14px"
            width="14px"
          />{" "}
        </IconButton>{" "}
      </DialogTitle>
      <DialogContent>
        <Typography>
          {Translation?.AccessProblemDeduction}
        </Typography>
      </DialogContent>
      <DialogActions align="center">
        <Button
          onClick={() => handleUnlock()}
          type="submit"
          variant="contained"
        >
          {Translation?.AccessHint}
        </Button>
        <Button
          onClick={() => handleClose()}
          variant="outlined"
          color="secondary"
        >
          {Translation?.Cancel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CompleteSolutionConfirmation;
